import { Header } from "./style";
import LogoHeader from "../../assets/logo512.webp";
import { useState } from "react";
import { FiMenu } from "react-icons/fi";

function HeaderComponent() {
  const [ linkId, setLinkId ] = useState("home")
  const [ menu, setMenu ] = useState("none")

  return (
    <>
      <Header id="theheader" linkId={linkId} menu={menu}>
        <div id="home">
          <figure>
            <img src={LogoHeader} alt="CDV - Blocos e pisos de concreto" />
          </figure>
          <ul id="linksDesktop">
            <li><a id="sobre-o-curso" href="#curso" onClick={(e) => setLinkId(`${e.target.id}`)}>Sobre o curso</a></li>
            <li><a id="diferenciais" href="#osdiferenciais" onClick={(e) => setLinkId(`${e.target.id}`)}>Diferenciais</a></li>
            <li><a id="processos" href="#passopasso" onClick={(e) => setLinkId(`${e.target.id}`)}>Processos</a></li>
            <li><a id="quem-sou" href="#quemsou" onClick={(e) => setLinkId(`${e.target.id}`)}>Quem sou</a></li>
            <li><a id="faq" href="#thefaq" onClick={(e) => setLinkId(`${e.target.id}`)}>FAQ</a></li>
          </ul>
          <FiMenu id="menuHamb" onClick={() => setMenu("flex")}/>
        </div>
        <section id="linksMobile" style={{ display: menu }}>
          <ul>
            <li onClick={() => setMenu("none")}><a id="sobre-o-produto" href="#curso" onClick={(e) => setLinkId(`${e.target.id}`)}>Sobre o curso</a></li>
            <li onClick={() => setMenu("none")}><a id="diferenciais" href="#osdiferenciais" onClick={(e) => setLinkId(`${e.target.id}`)}>Diferenciais</a></li>
            <li onClick={() => setMenu("none")}><a id="processos" href="#passopasso" onClick={(e) => setLinkId(`${e.target.id}`)}>Processos</a></li>
            <li onClick={() => setMenu("none")}><a id="quem-sou" href="#quemsou" onClick={(e) => setLinkId(`${e.target.id}`)}>Quem sou</a></li>
            <li onClick={() => setMenu("none")}><a id="faq" href="#thefaq" onClick={(e) => setLinkId(`${e.target.id}`)}>FAQ</a></li>
          </ul>
        </section>
      </Header>
    </>
  );
}

export default HeaderComponent;
